import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_Interface_getQueryString extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_interface_getquerystring">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.Interface.getQueryString</h2>
              <p>
                NL.Interface.getQueryString is a method that allows you to get a
                variable from the querystring in the Nexoid Application.
              </p>
              <WorkflowCompatibility front={true} back={false} />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.Interface.getQueryString Example</h2>
              <p>This example gets the variable "test".</p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">parameter</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonA">"</span>
                  <span className="jsonG">test</span>
                  <span className="jsonA">";</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  {" "}
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">value</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">Interface</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">getQueryString</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">parameter</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_Interface_getQueryString;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_Interface_getQueryString.js